import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PriceGroupReferenceService extends BaseReferenceService {
  constructor() {
    super('PriceGroupReference');
  }
}
